module.exports = __webpack_public_path__ + "static/pic13-178e0a7ab1231f2847a6fd5854b854cc.png";